module.exports = __webpack_public_path__ + "assets/905ecc707b8dcf6c462352e531951286.jpg";